/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Select_Source_Embed_LabelInputs */

const en_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Source Files (.mp4, .mov, .mpg, .mxf, etc)`)
};

const fr_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner les fichiers source (.mp4, .mov, .mpg, .mxf, etc)`)
};

const de_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelldateien auswählen (.mp4, .mov, .mpg, .mxf usw.)`)
};

const it_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i file sorgente (.mp4, .mov, .mpg, .mxf, ecc.)`)
};

const ru_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите исходные файлы (.mp4, .mov, .mpg, .mxf и т. д.)`)
};

const es_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivos de origen (.mp4, .mov, .mpg, .mxf, etc.)`)
};

const zh_cn2_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择源文件（.mp4、.mov、.mpg、.mxf 等）`)
};

const ja_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースファイルを選択（.mp4、.mov、.mpg、.mxfなど）`)
};

const hi_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत फ़ाइलें चुनें (.mp4, .mov, .mpg, .mxf, आदि)`)
};

const pt_pt2_drastic_tech_select_source_embed_label = /** @type {(inputs: Drastic_Tech_Select_Source_Embed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os arquivos de origem (.mp4, .mov, .mpg, .mxf, etc.)`)
};

/**
* | output |
* | --- |
* | "Select Source Files (.mp4, .mov, .mpg, .mxf, etc)" |
*
* @param {Drastic_Tech_Select_Source_Embed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_select_source_embed_label = /** @type {((inputs?: Drastic_Tech_Select_Source_Embed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Select_Source_Embed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_select_source_embed_label(inputs)
	if (locale === "de") return de_drastic_tech_select_source_embed_label(inputs)
	if (locale === "it") return it_drastic_tech_select_source_embed_label(inputs)
	if (locale === "ru") return ru_drastic_tech_select_source_embed_label(inputs)
	if (locale === "es") return es_drastic_tech_select_source_embed_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_select_source_embed_label(inputs)
	if (locale === "ja") return ja_drastic_tech_select_source_embed_label(inputs)
	if (locale === "hi") return hi_drastic_tech_select_source_embed_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_select_source_embed_label(inputs)
	return en_drastic_tech_select_source_embed_label(inputs)
});